export default "__VITE_ASSET__D$gyg2xr__"